import {dateTimeStringToTimeFormat} from "@/utils/dateTimeStringToTimeFormat";
import {dateStringToTimeFormat} from "@/utils/dateStringToTimeFormat";

export function parseIcs(payload: string): any {
    const lines = payload.split('\r\n');
    let events: any[] = [];
    let event: any = {};
    let inEvent = false;
    for (let line of lines) {
        if (line.startsWith('BEGIN:VEVENT')) {
            inEvent = true;
            event = {};
        } else if (line.startsWith('END:VEVENT')) {
            inEvent = false;
            events.push(event);
        } else if (inEvent) {
            let [key, value] = line.split(':', 2);

            if (key === 'DESCRIPTION' && value?.includes('galleryUuid')) {
                const foundGallerUuidMatches = String(value).match(/\[galleryUuid\=([a-zA-Z0-9-]*)\]/);

                event['galleryUuid'] = foundGallerUuidMatches?.[1].replace(/[^a-zA-Z0-9-]*/, '').replace("\n", '') || 'not found';
            } else if (key === 'DTSTART') {
                event['dtstart'] = (value ? dateTimeStringToTimeFormat(value.trim()) : undefined);
            } else if (key === 'DTEND') {
                event['dtend'] = (value ? dateTimeStringToTimeFormat(value.trim()) : undefined);
            } else if (key === 'DTSTART;VALUE=DATE') {
                event['dtstartext'] = (value ? dateStringToTimeFormat(value.trim()) : undefined);
            } else if (key === 'DTEND;VALUE=DATE') {
                event['dtendext'] = (value ? dateStringToTimeFormat(value.trim()) : undefined);
            } else if (key.startsWith('DTSTART;TZID')) {
                event['dtstarttzid'] = (value ? dateStringToTimeFormat(value.trim()) : undefined);
            } else {
                event[key.toLowerCase()] = (value ? value.trim() : undefined);
            }
        }
    }

    console.log('herey', events);
    return events;
}